<template>
  <div>
    <Section>
      <template #header>
        <div class="font-weight-bold">Coming Soon</div>
      </template>

      Users who send referrals will soon be rewarded.  You must have a W9 on file
      to qualify.  If you haven't given the required information before we
      activate this feature, you will not be eligible for rewards.
    </Section>

    <Section>
      <template #header>
        <div class="font-weight-bold">
          W9 <span class="red--text">- ACTION NEEDED</span>
        </div>
      </template>

      <div>
        In order to start earning rewards for referrals you must have a w9 on file. 
        Please tap the "Get Started" button below and fill out the form.  Once
        you're done, you are ready to 
        <span class="primary--text font-weight-bold">start earning rewards</span>
        for the referrals you send.
      </div>
    </Section>

    <div class="d-flex justify-center mt-4">
      <v-btn color="primary" width="60%" :to="{ name: 'w9/certification' }">
        Get Started
      </v-btn>
    </div>
  </div>
</template>

<script>
import { Section } from '@/components/pages'

export default {
  name: 'NoW9Section',

  components: { Section },
}
</script>